import { Col, Form, Input, Modal, Row, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { dictionaryApi } from "api/dictionary.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Dictionary, DictionaryType } from "types/dictionary";
import { ModalStatus } from "types/modal";
import { rules } from "utils/rule";

interface Props {
  onClose?: () => void;
  onSubmit?: () => void;
}

export interface ReviewModal {
  handleCreate: () => void;
  handleUpdate: (data: Dictionary) => void;
  handleClose: () => void;
}

const { TextArea } = Input;

export const ReviewModal = React.forwardRef(
  ({ onClose, onSubmit }: Props, ref) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Partial<Dictionary>>({});
    const [status, setStatus] = useState<ModalStatus>("create");
    const [form] = useForm<Dictionary>();

    useImperativeHandle(
      ref,
      () => ({
        handleCreate,
        handleUpdate,
        handleClose,
      }),
      []
    );

    const handleCreate = () => {
      form.resetFields();
      setData({});
      setStatus("create");
      setVisible(true);
    };

    const handleUpdate = (data: Dictionary) => {
      form.setFieldsValue({ ...data });
      setData(data);
      setStatus("update");
      setVisible(true);
    };

    const handleClose = () => {
      setVisible(false);
      onClose?.();
    };

    const onSubmitData = async () => {
      setLoading(true);
      try {
        await form.validateFields();
        const { avatar, description, name } = form.getFieldsValue();

        await dictionaryApi.create({
          dictionary: {
            avatar,
            description,
            name,
            type: DictionaryType.ReviewSample,
          },
        });

        message.success("Tạo mới thành công");
        onSubmit?.();
        handleClose();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    const onUpdateData = async () => {
      setLoading(true);
      try {
        await form.validateFields();
        const { id, avatar, description, name } = form.getFieldsValue();

        await dictionaryApi.update(id, {
          dictionary: {
            avatar,
            description,
            name,
            type: DictionaryType.ReviewSample,
          },
        });

        message.success("Cập nhật thành công");
        onSubmit?.();
        handleClose();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    // const MAIN_KEY = "discounting";

    return (
      (<Modal
        afterClose={() => {
          form.resetFields();
        }}
        onCancel={handleClose}
        open={visible}
        title={status == "create" ? "Thêm đánh giá" : "Cập nhật đánh giá"}
        style={{ top: 20 }}
        width={800}
        cancelText="Đóng"
        confirmLoading={loading}
        onOk={status == "create" ? onSubmitData : onUpdateData}
      >
        <Form layout="vertical" form={form}>
          <Form.Item hidden name={"id"}>
            <Input />
          </Form.Item>
          <Row>
            <Col span={24}>
              <Form.Item shouldUpdate={true}>
                {() => {
                  return (
                    <Form.Item
                      label="Ảnh đại diện (Tỉ lệ 1/1)"
                      required
                      rules={rules}
                      name="avatar"
                    >
                      <SingleImageUpload
                        width={150}
                        height={150}
                        onUploadOk={(path: string) => {
                          console.log("onUploadOk:", path);
                          form.setFieldsValue({
                            avatar: path,
                          });
                        }}
                        imageUrl={form.getFieldValue("avatar")}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Tên khách hàng" name={"name"} rules={rules}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Nội dung đánh giá"
                name={"description"}
                rules={rules}
              >
                <TextArea rows={3} autoSize={false} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>)
    );
  }
);
